/**
 * @generated SignedSource<<dad4f7e1ba6b5990cc461c24c7d26a99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CardBrand = "AMERICAN_EXPRESS" | "CHINA_UNIONPAY" | "DISCOVER" | "DISCOVER_DINERS" | "EBT" | "EFTPOS" | "FELICA" | "INTERAC" | "JCB" | "MASTERCARD" | "OTHER_BRAND" | "SQUARE_CAPITAL_CARD" | "SQUARE_GIFT_CARD" | "UNKNOWN" | "VISA";
export type DisableSquareCardOnFileInput = {
  cardId: string;
};
export type useDisableSquareCardOnFileMutation$variables = {
  input: DisableSquareCardOnFileInput;
};
export type useDisableSquareCardOnFileMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string;
    } | null | undefined>;
    readonly squareCard: {
      readonly cardBrand: CardBrand;
      readonly default: boolean;
      readonly enabled: boolean;
      readonly id: string;
      readonly lastFour: string;
      readonly " $fragmentSpreads": FragmentRefs<"SelectedPaymentMethodFragment" | "SquareCardFragment">;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useDisableSquareCardOnFileMutation = {
  response: useDisableSquareCardOnFileMutation$data;
  variables: useDisableSquareCardOnFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v3 = {
  "alias": "message",
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cardBrand",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastFour",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "default",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDisableSquareCardOnFileMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "DisableSquareCardOnFilePayload",
        "kind": "LinkedField",
        "name": "disableSquareCardOnFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SquareCardOnFile",
            "kind": "LinkedField",
            "name": "squareCard",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SquareCardFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SelectedPaymentMethodFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDisableSquareCardOnFileMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "DisableSquareCardOnFilePayload",
        "kind": "LinkedField",
        "name": "disableSquareCardOnFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SquareCardOnFile",
            "kind": "LinkedField",
            "name": "squareCard",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberPackageConnection",
                "kind": "LinkedField",
                "name": "memberPackages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "096565301c50ca00581297b10b289d62",
    "id": null,
    "metadata": {},
    "name": "useDisableSquareCardOnFileMutation",
    "operationKind": "mutation",
    "text": "mutation useDisableSquareCardOnFileMutation(\n  $input: DisableSquareCardOnFileInput!\n) {\n  responsePayload: disableSquareCardOnFile(input: $input) {\n    errors {\n      __typename\n      field\n      message: code\n    }\n    success\n    squareCard {\n      id\n      cardBrand\n      lastFour\n      enabled\n      default\n      ...SquareCardFragment\n      ...SelectedPaymentMethodFragment\n    }\n  }\n}\n\nfragment SelectedPaymentMethodFragment on SquareCardOnFile {\n  id\n  cardBrand\n  enabled\n  expMonth\n  expYear\n  lastFour\n  default\n  user {\n    id\n  }\n  memberPackages {\n    count\n  }\n}\n\nfragment SquareCardFragment on SquareCardOnFile {\n  __typename\n  id\n  cardBrand\n  enabled\n  expMonth\n  expYear\n  lastFour\n  default\n}\n"
  }
};
})();

(node as any).hash = "f2b259ea9d61664fc19d91bc009c7223";

export default node;
